import React from 'react';
import { unitStatusColors, unitStatusLabels } from '../../../../helpers/unitStatusConfig';

/**
 * Legenda de cores do mapa de vendas.
 */
function SalesMapLegend() {
    return (
        <div className="sales-map-legend">
            {Object.entries(unitStatusColors).map(([key]) => (
                <span key={key} className="legend-item">
                    <span
                        className="legend-dot"
                        style={{ backgroundColor: unitStatusColors[key] }}
                    />
                    {unitStatusLabels[key]}
                </span>
            ))}
        </div>
    );
}

export default SalesMapLegend;
